module.exports = __webpack_public_path__ + "img/yangtze_river_2013.5934c4a6.png";